import { motion, AnimatePresence } from "framer-motion";
import { IoCheckmarkCircleOutline } from "react-icons/io5";

interface SubmissionSplashProps {
  isVisible: boolean;
  title?: string;
  message?: string;
}

export const SubmissionSplash = ({
  isVisible,
  title = "Criando ocorrência",
  message = "Estamos processando sua denúncia e enviando as informações...",
}: SubmissionSplashProps) => {
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-green-500 via-green-600 to-emerald-700"
        >
          <div className="flex flex-col items-center justify-center space-y-6 px-4">
            {/* Ícone animado */}
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{
                scale: [0, 1.2, 1],
                rotate: 0,
              }}
              transition={{
                duration: 0.6,
                ease: "easeOut",
              }}
              className="relative"
            >
              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-2xl"
              >
                <IoCheckmarkCircleOutline className="text-6xl text-green-600" />
              </motion.div>

              {/* Círculos de pulso */}
              <motion.div
                animate={{
                  scale: [1, 2, 2],
                  opacity: [0.5, 0, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeOut",
                }}
                className="absolute inset-0 bg-white rounded-full"
              />
              <motion.div
                animate={{
                  scale: [1, 2, 2],
                  opacity: [0.5, 0, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeOut",
                  delay: 0.5,
                }}
                className="absolute inset-0 bg-white rounded-full"
              />
            </motion.div>

            {/* Texto animado */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="text-center space-y-3"
            >
              <h2 className="text-3xl font-bold text-white drop-shadow-lg">
                {title}
              </h2>
              <motion.div
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="flex items-center justify-center space-x-2"
              >
                <div className="w-2 h-2 bg-white rounded-full" />
                <div className="w-2 h-2 bg-white rounded-full" />
                <div className="w-2 h-2 bg-white rounded-full" />
              </motion.div>
            </motion.div>

            {/* Mensagem de progresso */}
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5 }}
              className="text-white/90 text-sm max-w-xs text-center"
            >
              {message}
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
